const { Linking } = require("react-native");
const { select, call, put, fork } = require("redux-saga/effects");
const {
  setReferer,
  setRefererSuccess,
  setHashResult,
  handleAppLink,
} = require("@actions/deepLink.actions");
const { getAppLinkParams, OPEN_EVENTS } = require("@lib/AppLinkEventParams");
const { applinksOpen, postApplinkEvent } = require("@lib/applinks/api");
const { default: getUserData } = require("@lib/applinks/getUserData");
const { getData, setData } = require("@lib/storage");
const {
  APPLINK_URI_SCHEME,
  APPLINK_PREFIX,
  LEGACY_BRANCH_PREFIX,
} = require("@navigation");
const { APPLINK_CONFIGURED, HANDLE_APPLINK } = require("@reducers/actionTypes");
const { getApplinkData } = require("@services/api");
const { getRefererData } = require("@utils/PlayReferrer");
const { generateLinkParams } = require("@utils/URL");
const URLParse = require("url-parse");

const getReferer = async () => {
  let referer;
  let referrerString = null;
  try {
    referer = await getRefererData();
  } catch (e) {
    console.log(e);
  }

  let { installReferrer } = referer || {};
  referrerString = installReferrer;

  if (installReferrer) {
    const cleanReferer = decodeURIComponent(
      decodeURIComponent(installReferrer),
    );

    const refererParams = generateLinkParams(cleanReferer).getAll();
    if (refererParams && !!Object.values(refererParams).length) {
      installReferrer = refererParams;
    }
  }

  if (installReferrer?.hash) {
    try {
      const {
        data: { data: hashData },
      } = await getApplinkData(installReferrer.hash);
      referer.hashResult = hashData;
    } catch (e) {
      console.log(e);
    }
  }
  referer.installReferrer = installReferrer;
  referer.referrerString = referrerString;
  return referer;
};

function* setRefererData() {
  try {
    let referer = yield select((state) => state.deepLink.referer);
    if (!referer) {
      referer = yield call(getReferer);
      yield put(setReferer(referer));
    }
    yield put(setRefererSuccess());
  } catch (e) {
    console.log(e);
  }
}

const getAppLinkDataByUrl = async (url) => {
  const urlHash = URLParse(url).pathname?.replace("/", "");
  const {
    data: { data: hashData },
  } = await getApplinkData(urlHash);
  return hashData;
};

const APPLINK_INSTALL_FIRED = "APPLINK_INSTALL_FIRED";

function* fireAppLinkEvent() {
  try {
    const appLinkEventFired = yield call(getData, APPLINK_INSTALL_FIRED);
    if (appLinkEventFired) return;
    const userData = yield call(getUserData);
    const { data: appOpenStatus } = yield call(applinksOpen, {
      idfa: userData.idfa,
      user_data: userData,
    });

    const code = appOpenStatus?.code;
    const appLinkEventParams = yield call(getAppLinkParams, {
      event_name: code,
    });

    if (code === OPEN_EVENTS.install || code === OPEN_EVENTS.reinstall) {
      yield call(postApplinkEvent, appLinkEventParams);
      yield call(setData, APPLINK_INSTALL_FIRED, true);
    }
  } catch (e) {
    console.log("Applink Event failed", e);
  }
}

function* setAppLink({ payload } = {}) {
  try {
    let url = payload;
    let cleanUrl = url;
    let searchParams, hashResult;

    if (!url) {
      url = yield call(Linking.getInitialURL);
      if (url?.startsWith(APPLINK_URI_SCHEME)) {
        url = url.replace(APPLINK_URI_SCHEME, "");
      }
    }
    if (url) {
      try {
        cleanUrl = decodeURIComponent(decodeURIComponent(url));
        searchParams = generateLinkParams(cleanUrl).getAll();
      } catch (e) {}
      if (url.startsWith(APPLINK_PREFIX) && !url.includes("app_screen")) {
        hashResult = yield call(getAppLinkDataByUrl, cleanUrl);
        yield put(setHashResult({ ...hashResult, href: url, searchParams }));
      }
      if (
        (url?.startsWith(APPLINK_PREFIX) ||
          url.startsWith(LEGACY_BRANCH_PREFIX)) &&
        url.includes("app_screen")
      ) {
        yield put(
          setHashResult({
            href: url,
            searchParams,
            nav_params: searchParams,
            nav_screen: searchParams?.app_screen,
          }),
        );
      }
    }
    yield put({ type: APPLINK_CONFIGURED });
    yield call(fireAppLinkEvent);
    yield put(handleAppLink({ forceNavigate: true }));
  } catch (e) {
    console.log("Applink crashed ", e);
  }
}

function* configureApplinks() {
  yield call(setRefererData);
  yield call(setAppLink);
}

export { configureApplinks, setAppLink };
